<template lang="pug">
    div.control-modal-layout(v-click-outside="clickOutside" :style="theStyle")
        slot
</template>

<script>
import _ from 'lodash'
import { createPopper } from '@popperjs/core'
import ResizeSensor from 'resize-sensor'
import EventBus from '../lib/event-bus'
import Events from '../lib/events'

export default {
    name: 'control-modal-layout',

    props: {
        level: {
            type: Number,
            required: true,
        },
        element: {
            type: HTMLElement,
            required: true,
        },
        offsetX: {
            type: Number,
            default: -2,
        },
        offsetY: {
            type: Number,
            default: -2,
        },
        placement: {
            type: String,
            default: 'bottom-end',
        },
        wide: {
            type: Boolean,
        },
        disableAutoClose: {
            type: [Boolean, Function],
        },
    },

    data() {
        return {
            popper: null,
            elementClickCheckedOnce: false,
            modalWidth: null,
        }
    },

    computed: {
        theStyle() {
            return {
                'width': this.modalWidth ? `${this.modalWidth}px` : null,
            }
        },
    },

    methods: {
        close() {
            EventBus.$emit(Events.CLOSE_MODAL, this.level)
        },
        clickOutside(e) {
            if (_.isFunction(this.disableAutoClose) ? this.disableAutoClose() : this.disableAutoClose) {
                return
            }
            if (this.elementClickCheckedOnce || !e.composedPath().includes(this.element)) {
                this.close()
            }
            this.elementClickCheckedOnce = true
        },
        elementResize() {
            this.modalWidth = this.element.offsetWidth - this.offsetX * 2
        },
    },

    mounted() {
        this.popper = createPopper(this.element, this.$el, {
            placement: this.placement,
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [this.offsetX, this.offsetY],
                    },
                },
                {
                    name: 'preventOverflow',
                    options: {
                        padding: 10,
                    },
                },
            ],
        })

        if (this.wide) {
            this.elementResize()
            new ResizeSensor(this.element, this.elementResize)
        }
    },

    beforeDestroy() {
        this.popper.destroy()
    },
}
</script>
